import {
  DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_BEGIN,
  DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_SUCCESS,
  DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_FAILURE,
  DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function deleteExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_BEGIN,
    });
    const { version, projectId, externalDatabaseId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-db/${externalDatabaseId}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_SUCCESS,
            data: res,
          });
          toast.success('Deleted Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          toast.error(`Failed: to Delete ExternalDatabase !`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteExternalDatabaseError() {
  return {
    type: DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        deleteExternalDatabasePending: true,
        deleteExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        deleteExternalDatabasePending: false,
        deleteExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        deleteExternalDatabasePending: false,
        deleteExternalDatabaseError: action.data.error,
      };

    case DATA_CONNECTOR_DELETE_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        deleteExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
